module.exports = __webpack_public_path__ + "img/Dantam Bridal 21.3369ea8d.jpg";